import { render, staticRenderFns } from "./useraddress.vue?vue&type=template&id=2c3eb478&"
import script from "./useraddress.vue?vue&type=script&lang=js&"
export * from "./useraddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports